'use strict';

/**
 * US / Latin American Spanish (es-US).
 * Prefer Latin American vocabulary (e.g. email, celular-adjacent phrasing)
 * over Spain-specific forms. Keep keys identical to en-AU.js.
 */
module.exports = {
  login: {
    trustLine:
      'De la confianza de equipos en profesiones reguladas en todo el mundo — donde las conversaciones difíciles importan.',
    pitchTitle: 'Conversaciones reales, antes de que lo sean.',
    pitchBody:
      'Practica las conversaciones difíciles — la objeción, el diagnóstico, la mala noticia — y recibe feedback mientras aún importa.',
    orgManagedSignIn: 'El inicio de sesión lo administra tu organización.',
    orgOnAudirie: '{name} en Audirie',
    welcomeBack: 'Bienvenido de nuevo.',
    findYourWayIn: 'Vamos a encontrar tu acceso.',
    startWithWorkEmail: 'Empieza con tu email de trabajo — te llevamos por el camino correcto.',
    workEmailTellsUs:
      'Tu email de trabajo nos indica cómo inicia sesión tu organización. No necesitas contraseña si usan inicio de sesión único.',
    workEmail: 'Dirección de email',
    continue: 'Continuar',
    pickUpWhereLeftOff: 'Continúa justo donde lo dejaste.',
    continueAs: 'Continuar como {email}',
    singleSignOn: 'Inicio de sesión único',
    singleSignOnWithOrg: 'Inicio de sesión único · {orgName}',
    audiriePassword: 'Contraseña de Audirie',
    useDifferentAccount: 'Usar otra cuenta',
    oneMoment: 'Un momento…',
    checkingOrganisationSignIn: 'Estamos revisando cómo inicia sesión tu organización.',
    whichOrgHeading: '¿Con cuál estás iniciando sesión?',
    belongsToMultipleOrgs: '{email} pertenece a más de una organización en Audirie.',
    yourOrganisation: 'Tu organización',
    useDifferentEmail: 'Usar otro email',
    orgTakesItFromHere: '{name} se encarga desde aquí',
    yourOrgTakesItFromHere: 'Tu organización se encarga desde aquí',
    openingTheirSignIn:
      'Estamos abriendo su página de inicio de sesión — terminas allí y vuelves aquí. Nada de lo que ingreses en su página nos llega.',
    notYouStartAgain: '¿No eres tú? Empezar de nuevo',
    verifiedGettingReady: 'Ya estás verificado. Preparando tu espacio de práctica.',
    orgSignInComplete: 'El inicio de sesión de {name} está completo',
    accountNotReady: 'Tu cuenta aún no está lista',
    ssoWorkedButNeedsSetup:
      'El inicio de sesión único funcionó, pero tu cuenta de Audirie aún necesita configurarse antes de entrar.',
    noRoleAssigned:
      'Tu cuenta todavía no tiene un rol asignado. Contacta al administrador de tu organización.',
    backToLogin: 'Volver al inicio de sesión',
    orgDidntLetUsIn: '{name} no nos dejó entrar',
    couldntCompleteSso: 'No pudimos completar el inicio de sesión único',
    orgSignInDeclined:
      'El servicio de inicio de sesión de tu organización rechazó la solicitud o no respondió. No hay nada mal con tu cuenta de Audirie.',
    ifKeepsHappening:
      'Si sigue pasando, avisa a tu equipo de IT — y escríbenos a support@audirie.com para ayudarte.',
    tryAgain: 'Intentar de nuevo',
    orgSignedInAsSomeoneElse: '{name} tiene iniciada la sesión de otra persona',
    differentAccountSignedIn: 'Hay otra cuenta con sesión iniciada',
    orgSignOnConnectedElsewhere:
      'El inicio de sesión de tu organización sigue conectado a otro email en este navegador.',
    signOutCorporateFirst:
      'Cierra primero la sesión de esa cuenta corporativa, luego vuelve e inténtalo con el email que quieres usar.',
    enterPassword: 'Ingresa tu contraseña',
    change: 'cambiar',
    password: 'Contraseña',
    forgotPassword: '¿Olvidaste tu contraseña?',
    signIn: 'Iniciar sesión',
    resetPassword: 'Restablecer tu contraseña',
    wellEmailLink: 'Te enviaremos un email con un enlace para elegir una nueva.',
    send: 'Enviar',
    cancel: 'Cancelar',
    emailRequired: 'El email es obligatorio',
    emailAndPasswordRequired: 'El email y la contraseña son obligatorios',
    emailNotFound: 'No encontramos ese email.',
    passwordIncorrect: 'Tu contraseña es incorrecta.',
    ssoUnavailable:
      'El inicio de sesión único no está disponible en este momento. Inicia sesión con tu contraseña.',
    popupBlocked:
      'Tu navegador bloqueó la ventana de inicio de sesión. Permite ventanas emergentes en este sitio y luego actualiza la página para continuar.',
    couldNotLogIn:
      'Lamentablemente no pudimos iniciar tu sesión. Escribe a support@audirie.com si el problema continúa.',
    resetEmailSent:
      'Si el email que indicaste está en nuestros registros, recibirás un mensaje con un enlace para restablecer tu contraseña.',
    needValidEmail: 'Indica un email válido.',
    mustRegisterFirst:
      'Debes registrarte en Audirie antes de completar esta tarea. Si no tienes un enlace de registro, contáctanos en support@audirie.com',
    couldNotResetPassword:
      'No pudimos restablecer tu contraseña. Inténtalo de nuevo. Si el problema continúa, contáctanos en support@audirie.com'
  }
};
